import { render, staticRenderFns } from "./EmojiComponent.vue?vue&type=template&id=0cd246a2&"
import script from "./EmojiComponent.vue?vue&type=script&lang=js&"
export * from "./EmojiComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports